import { API_URL_PROJECT } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const banProject = (uuid: string) =>
  apiInstance({
    url: `${API_URL_PROJECT}${uuid}/banned`,
    method: "put",
  });

export default banProject;
